<template>
  <div class="hm-home">
    <el-card>
      <div class="flex flex-end item-center">
        <el-input
            placeholder="请输入会员姓名/手机号查询"
            v-model="query.keyWords"
            style="width: 180px"
            size="small"
            class="mr20"
            clearable>
        </el-input>
        <el-button type="primary" size="small" @click="paging(1)">查询</el-button>
        <el-button
            type="success"
            size="small"
            :loading="isOutputing"
            @click="output"
        >导出</el-button
        >
      </div>
      <div class="table">
        <div class="send-table">
          <el-table border :data="list" @sort-change="sortChange" style="width: 100%">
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="signedName"
              label="活动名称"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="memberName"
              label="会员姓名"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="会员手机"
              prop="memberMobile"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="addupCount"
              label="累计签到次数"
              sortable="custom"
              width="200"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="updateTime"
              label="最后签到时间"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="viewDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
        >
        </el-pagination>
      </div>
    </el-card>

    <el-dialog
      title="奖励详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <div class="dialog-body">
        <div class="mb20">
          <div class="table">
            <el-table stripe border :data="detailsList" id="table" size="small">
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                :index="index => index + (detailsCurrentPage - 1) * 10 + 1"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                prop="signedName"
                align="center"
                label="活动名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="会员姓名"
                prop="memberName"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="会员手机"
                prop="memberMobile"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="签到时间"
                prop="createTime"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="活动奖励"
                prop="prizzName"
              >
              </el-table-column>
            </el-table>
          </div>
          <div class="text-center">
            <el-pagination
              background
              layout="total,sizes,  prev, pager, next, jumper"
              :total="detailsTotal"
              @current-change="detailsPaging"
              :current-page="detailsCurrentPage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      detailsCurrentPage: 1,
      total: 0,
      detailsTotal: 0,
      list: [],
      detailsList: [],
      dialogVisible: false,
      currentRow: {},
      signedType: "",
      query: {
        keyWords: "",
        orderByType: "",
        orderByValue: ""
      },
      isOutputing: false
    };
  },
  created() {
    this.signedActivityId = this.$route.query.signedActivityId;
    this.signedType = this.$route.query.signedType;
    this.queryList();
  },
  methods: {
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        let params = {
          signedActivityId: this.signedActivityId,
          pageNo: 1,
          pageSize: 999999
        }
        const searchCondition = JSON.parse(JSON.stringify(this.query));
        Object.assign(params, searchCondition);
        this.$store.dispatch("querySignActDetails", params)
            .then((res) => {
              if (res.code === "0") {
                const list = res.result.records;
                const tHeader = [
                  "活动名称",
                  "会员姓名",
                  "会员手机",
                  "累计签到次数",
                  "最后签到时间"
                ];
                const filterVal = [
                  "signedName",
                  "memberName",
                  "memberMobile",
                  "addupCount",
                  "updateTime"
                ];
                const data = this.formatJson(filterVal, list);

                exportJsonToExcel(tHeader, data, "签到活动列表");
                this.isOutputing = false;
              } else {
                this.isOutputing = false;
              }
            })
            .catch(() => {
              this.isOutputing = false;
            });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    sortChange(sort) {
      console.log(sort);
      this.query.orderByType = sort.prop;
      if (null == sort.order) {
        this.query.orderByValue = "";
      } else if ("descending" == sort.order) {
        this.query.orderByValue = "desc";
      } else {
        this.query.orderByValue = "asc";
      }
      this.queryList();
      /*this.sort = {
        order: sort.order,
        prop: sort.prop
      };
      this.queryList();*/
    },
    viewDetail(row) {
      this.dialogVisible = true;
      this.currentRow = row;
      this.detailsCurrentPage = 1;
      this.queryDetailsList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    detailsPaging(page) {
      this.detailsCurrentPage = page;
      this.queryDetailsList();
    },
    async queryList() {
      let params = {
        signedActivityId: this.signedActivityId,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      }
      const searchCondition = JSON.parse(JSON.stringify(this.query));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("querySignActDetails", params);
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    async queryDetailsList() {
      console.log("this.detailsCurrentPage::", this.detailsCurrentPage);
      const { result } = await this.$store.dispatch(
        "querySingleSignActDetails",
        {
          signedActivityId: this.signedActivityId,
          centerId: this.currentRow.centerId,
          pageNo: this.detailsCurrentPage,
          pageSize: this.pageSize,
          signedType: this.signedType
        }
      );
      const { records, total } = result;
      this.detailsList = records;
      this.detailsTotal = total;
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  padding: 10px 0;
}
.qrcode-wrapper {
  text-align: center;
  img {
    width: 200px;
    height: 200px;
  }
}
.coupon-name {
  color: #4680ff;
}
</style>
